import { render, staticRenderFns } from "./BrickTimerFrequencySettings.vue?vue&type=template&id=619a40e8&"
import script from "./BrickTimerFrequencySettings.vue?vue&type=script&lang=js&"
export * from "./BrickTimerFrequencySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('619a40e8')) {
      api.createRecord('619a40e8', component.options)
    } else {
      api.reload('619a40e8', component.options)
    }
    module.hot.accept("./BrickTimerFrequencySettings.vue?vue&type=template&id=619a40e8&", function () {
      api.rerender('619a40e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Connection/BrickTimerFrequencySettings.vue"
export default component.exports